import { getErrorMessage } from '@/lib/utils/errors'

interface QueryErrorProps {
  // the error a TanStack Query hook surfaced
  error: unknown
  // shown when the server sent nothing better — keep it specific to the thing that failed
  fallback: string
  testId?: string
}

// a failed query used to render a flat "Failed to load X." no matter what went wrong, which
// threw away the message the backend had just taken the trouble to classify. this shows the
// server's own message instead — including, for an unclassified failure, the correlation id
// that ties it to the log line holding the real cause.
export const QueryError = ({ error, fallback, testId }: QueryErrorProps) => (
  <div className="flex items-center justify-center py-16" data-testid={testId}>
    <span className="text-red-500 text-center">{error ? getErrorMessage(error) : fallback}</span>
  </div>
)
